import api from './api';

export async function getLandingPageSettingsPublic() {
  const { data } = await api.get('/landing/settings');
  return data;
}

export async function getLandingPageSettingsAdmin() {
  const { data } = await api.get('/admin/landing-page/settings');
  return data;
}

export async function updateLandingPageSettings(payload) {
  const { data } = await api.patch('/admin/landing-page/settings', payload);
  return data;
}

export async function updateLandingLogoSettings(payload) {
  const { data } = await api.patch('/admin/landing-page/logo-settings', payload);
  return data;
}

export async function uploadLandingLogo(file) {
  const form = new FormData();
  form.append('logo', file);
  const { data } = await api.post('/admin/landing-page/logo', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}
